/*
 * @Descripttion: 
 * @Author: voanit
 * @Date: 2021-07-08 17:51:33
 * @LastEditors: voanit
 * @LastEditTime: 2021-11-23 16:13:37
 */
import { request } from './request'
const baseUrl = process.env.VUE_APP_BASEURL_USER
// 公告用户未读条数
export const getUnread = (params) => {
    return request({
        method: 'get',
        url: `${baseUrl}/api/v1/portal/notice/user/userUnread`,
        params
    })
}

// 公告更新用户已读状态
export const setNoticeRead = (data) => {
    return request({
        method: 'post',
        url: `${baseUrl}/api/v1/portal/notice/user/updateRead`,
        data
    })
}

// 获取公告列表
export const getNoticeList = (params) => {
    return request({
        method: 'get',
        url: `${baseUrl}/api/v1/portal/notice/user/list`,
        params: { systemId: 3, ...params }
    })
}

// // 获取系统消息列表
// export const getMessageList = (params) => {
//     return request({
//         method: 'get',
//         url: `${baseUrl}/api/v1/portal/user-notifications/lists`,
//         params
//     })
// }


// 系统消息更新已读状态
export const setMessageRead = (data) => {
  return request({
      method: 'post',
      url: `${baseUrl}/api/v1/portal/user-notifications/read`,
      data
  })
}

// 消息列表V2
export const getMessageList = (params) => {
  return request({
      method: 'get',
      url: `${baseUrl}/api/v1/portal/user-notifications/listsV2`,
      params
  })
}

// 用户未读条数
export const getUnreadTotal = (params) => {
  return request({
      method: 'get',
      url: `${baseUrl}/api/v1/portal/user-notifications/user/user-unread`,
      params
  })
}
